import React, { createContext, useContext, useMemo } from 'react'
import { Form } from 'react-bootstrap'
import { type ClickNavigationSection } from '../../../components/NavigationWithSideBar/ClickNavigation'
import { ClicFpCodeSelect, type ClicFpCodeSelectProps } from './ClicFpCodeSelect'
import { useClicFpCodeField } from './useClicFpCodeField'

const ClicFpCodeSelectContext = createContext<ClicFpCodeSelectProps | null>(null)

const ClicFpCodeSection: React.FC = () => {
  const fpCodes = useContext(ClicFpCodeSelectContext)
  if (!fpCodes) {
    return null
  }

  return (
    <div className='d-flex flex-column'>
      <Form.Label>FP Codes</Form.Label>
      <ClicFpCodeSelect {...fpCodes} />
    </div>
  )
}

interface ClicFpCodeUpdateSectionsProps {
  children: (extraSections: ClickNavigationSection[]) => React.ReactNode
}

export const ClicFpCodeUpdateSections: React.FC<ClicFpCodeUpdateSectionsProps> = ({ children }) => {
  const fpCodes = useClicFpCodeField('update')
  const hasError = !!fpCodes.error

  const extraSections = useMemo<ClickNavigationSection[]>(
    () => [{ id: 'fpCodes', label: 'FP Codes', disabled: false, hasError, content: () => <ClicFpCodeSection /> }],
    [hasError],
  )

  return <ClicFpCodeSelectContext.Provider value={fpCodes}>{children(extraSections)}</ClicFpCodeSelectContext.Provider>
}
